module.exports = __webpack_public_path__ + "static/media/hingeHardwareMainImg.873ce000.png";